/* ═══════════════════════════════════════════════════════════════════════════
   eoh-chat-context-drawer.js  ·  Display — session context drawer

   Right-edge slide-over listing this session's Files and cited Sources.

   PERSISTENCE (the fix): files and sources are derived from S.history — which
   loadSession restores from the DB — so they survive refresh, chat-switch, and
   re-login. Files come from each message's `attachments` (already persisted).
   Sources are captured live AND written back onto the assistant message so they
   are saved with the session and restored on load. Rebuilds on
   window.eohOnConversationRendered (fired by eoh-chat.js after a load / on new chat).

   Gated by feature flag chat_context_drawer. Load AFTER the other chat modules.
   ═══════════════════════════════════════════════════════════════════════════ */
(function () {
  "use strict";

  var _dev = window.location.pathname.indexOf('/pages/erp-chat_dev') !== -1
          || window.location.search.indexOf('preview_theme_id=159788171482') !== -1
          || window.location.hostname !== 'erponlinehub.com';
  var API = (window.location.hostname === 'erponlinehub.com' && !_dev)
    ? 'https://erp-ai-backend.vercel.app'
    : 'https://erp-ai-backend-dev.vercel.app';

  var _flags = {};
  var _sources = [];   // deduped by url, rebuilt from S.history
  var _seen = {};
  var _open = false;

  function _tok()  { try { return localStorage.getItem('eoh_t') || ''; } catch (_) { return ''; } }
  function _auth() { var h = {}; var t = _tok(); if (t) h['Authorization'] = 'Bearer ' + t; return h; }
  function _esc(s) { return String(s == null ? '' : s).replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;').replace(/"/g,'&quot;'); }
  async function _getJSON(url) { try { var r = await fetch(url, { headers: _auth() }); if (!r.ok) return null; return await r.json(); } catch (_) { return null; } }
  function _host(u) { try { return new URL(u).hostname.replace(/^www\./, ''); } catch (_) { return ''; } }

  /* ── files: from the PERSISTED per-message attachments (survives reload) ─── */
  function _files() {
    var out = [];
    function add(name, kind) { if (!name) return; if (out.some(function (f) { return f.name === name; })) return; out.push({ name: name, kind: kind }); }
    var H = (window.S && window.S.history) || [];
    H.forEach(function (m) {
      if (m && Array.isArray(m.attachments)) {
        m.attachments.forEach(function (a) {
          if (!a || !a.name) return;
          var isImg = (a.kind === 'image') || (String(a.mime || '').indexOf('image') === 0);
          add(a.name, isImg ? 'image' : 'doc');
        });
      }
      if (m && m.exportFile && (m.exportFile.fileName || m.exportFile.name)) add(m.exportFile.fileName || m.exportFile.name, 'export');
      if (m && m.file && m.file.name) add(m.file.name, 'doc');
    });
    // Current turn's attachment (not yet in history)
    try { ((window.S && window.S.filesAttached) || []).forEach(function (f) { if (f && f.name) add(f.name, 'doc'); }); } catch (_) {}
    return out;
  }

  function _addSource(s) {
    if (!s || !s.url || _seen[s.url]) return;
    _seen[s.url] = 1;
    _sources.push({ title: s.title || s.source || _host(s.url), url: s.url, source: s.source || _host(s.url) });
  }

  /* ── rebuild sources from S.history (called on load / switch) ───────────── */
  function _rebuild() {
    _sources = []; _seen = {};
    var H = (window.S && window.S.history) || [];
    H.forEach(function (m) { if (m && m.role === 'assistant' && Array.isArray(m.sources)) m.sources.forEach(_addSource); });
    _badge();
    if (_open) _render();
  }

  /* ── live: collect sources from a completed reply + persist onto history ── */
  function _collect(data) {
    var srcs = (data && data.sources) || [];
    if (!Array.isArray(srcs) || !srcs.length) { _badge(); return; }
    srcs.forEach(_addSource);
    // Write back onto the just-finalized assistant message so it's saved + restored.
    setTimeout(function () {
      try {
        var H = (window.S && window.S.history) || [];
        for (var i = H.length - 1; i >= 0; i--) { if (H[i].role === 'assistant') { if (!H[i].sources) H[i].sources = srcs; break; } }
      } catch (_) {}
    }, 60);
    _badge();
    if (_open) _render();
  }

  /* ── render ──────────────────────────────────────────────────────────────── */
  function _render() {
    var body = document.getElementById('eoh-ctxd-body'); if (!body) return;
    var files = _files();
    var ficon = { image: '🖼️', export: '⬇️', doc: '📄' };
    var fh = files.length
      ? files.map(function (f) { return '<div class="ctxd-row"><span class="ic">' + (ficon[f.kind] || '📄') + '</span><span class="tx">' + _esc(f.name) + '</span></div>'; }).join('')
      : '<div class="ctxd-empty">No files in this session yet.</div>';
    var sh = _sources.length
      ? _sources.map(function (s, i) {
          return '<a class="ctxd-row lnk" href="' + _esc(s.url) + '" target="_blank" rel="noopener">' +
                 '<span class="n">' + (i + 1) + '</span>' +
                 '<span class="tx"><b>' + _esc(s.title) + '</b><small>' + _esc(s.source) + '</small></span></a>';
        }).join('')
      : '<div class="ctxd-empty">No sources cited yet.</div>';
    body.innerHTML =
      '<div class="ctxd-sec">Files this session <span class="ct">' + files.length + '</span></div>' + fh +
      '<div class="ctxd-sec">Resources / sources <span class="ct">' + _sources.length + '</span></div>' + sh;
  }
  function _badge() {
    var b = document.getElementById('eoh-ctxd-badge'); if (!b) return;
    var n = _sources.length + _files().length;
    b.textContent = n > 0 ? String(n) : '';
    b.style.display = n > 0 ? 'flex' : 'none';
  }

  function _toggle(force) {
    _open = (typeof force === 'boolean') ? force : !_open;
    var p = document.getElementById('eoh-ctxd'); var ov = document.getElementById('eoh-ctxd-ov');
    if (!p) return;
    p.classList.toggle('open', _open);
    if (ov) ov.style.display = _open ? 'block' : 'none';
    if (_open) _render();
  }

  function _build() {
    if (document.getElementById('eoh-ctxd')) return;
    var ov = document.createElement('div'); ov.id = 'eoh-ctxd-ov';
    ov.addEventListener('click', function () { _toggle(false); });
    document.body.appendChild(ov);

    var tab = document.createElement('button');
    tab.id = 'eoh-ctxd-tab'; tab.type = 'button'; tab.title = 'Session context';
    tab.innerHTML = '<span class="lbl">Context</span><span id="eoh-ctxd-badge"></span>';
    tab.addEventListener('click', function () { _toggle(); });
    document.body.appendChild(tab);

    var p = document.createElement('div'); p.id = 'eoh-ctxd';
    p.innerHTML =
      '<div class="ctxd-hd"><span>Session context</span><button id="eoh-ctxd-x" type="button" title="Close">✕</button></div>' +
      '<div id="eoh-ctxd-body" class="ctxd-body"></div>';
    document.body.appendChild(p);
    p.querySelector('#eoh-ctxd-x').addEventListener('click', function () { _toggle(false); });
  }

  function _css() {
    if (document.getElementById('eoh-ctxd-css')) return;
    var c = [
      '#eoh-ctxd-tab{position:fixed;right:0;top:50%;transform:translateY(-50%);z-index:60;background:var(--gl,#0a8a5f);color:#fff;border:none;border-radius:8px 0 0 8px;padding:12px 7px;cursor:pointer;writing-mode:vertical-rl;font-size:12px;font-family:inherit;box-shadow:-2px 0 10px rgba(0,0,0,.25);display:flex;align-items:center;gap:6px}',
      '#eoh-ctxd-tab .lbl{transform:rotate(180deg)}',
      '#eoh-ctxd-badge{display:none;background:#fff;color:var(--gl,#0a8a5f);border-radius:10px;min-width:16px;height:16px;font-size:10px;align-items:center;justify-content:center;padding:0 4px;writing-mode:horizontal-tb}',
      '#eoh-ctxd-ov{display:none;position:fixed;inset:0;background:rgba(0,0,0,.35);z-index:70}',
      '#eoh-ctxd{position:fixed;top:0;right:0;height:100%;width:330px;max-width:88vw;background:var(--bg2,#16202e);border-left:1px solid var(--border,#25324a);z-index:80;transform:translateX(100%);transition:transform .22s ease;display:flex;flex-direction:column;box-shadow:-8px 0 30px rgba(0,0,0,.4)}',
      '#eoh-ctxd.open{transform:translateX(0)}',
      '.ctxd-hd{display:flex;align-items:center;justify-content:space-between;padding:14px 16px;border-bottom:1px solid var(--border,#25324a);font-size:14px;font-weight:600;color:var(--text,#e8eef5)}',
      '#eoh-ctxd-x{background:none;border:none;color:var(--dim,#8a94a6);font-size:15px;cursor:pointer}',
      '.ctxd-body{overflow-y:auto;padding:10px 12px;flex:1}',
      '.ctxd-sec{font-size:11px;text-transform:uppercase;letter-spacing:.05em;color:var(--dim,#8a94a6);margin:12px 4px 6px;display:flex;gap:8px;align-items:center}',
      '.ctxd-sec .ct{background:var(--bg3,#111a2b);border-radius:9px;padding:0 7px;font-size:10px}',
      '.ctxd-row{display:flex;gap:9px;align-items:center;padding:8px 10px;border:1px solid var(--border,#25324a);border-radius:8px;margin-bottom:6px;background:var(--bg3,#111a2b);text-decoration:none;color:var(--text,#e8eef5);font-size:12px}',
      '.ctxd-row.lnk:hover{border-color:var(--gl,#0a8a5f)}',
      '.ctxd-row .tx{overflow:hidden;text-overflow:ellipsis;white-space:nowrap;display:flex;flex-direction:column}',
      '.ctxd-row .tx small{color:var(--dim,#8a94a6);font-size:10px}',
      '.ctxd-row .n{background:var(--gl,#0a8a5f);color:#fff;border-radius:50%;width:18px;height:18px;display:inline-flex;align-items:center;justify-content:center;font-size:10px;flex-shrink:0}',
      '.ctxd-empty{color:var(--dim,#8a94a6);font-size:12px;padding:6px 10px}'
    ].join('');
    var s = document.createElement('style'); s.id = 'eoh-ctxd-css'; s.textContent = c; document.head.appendChild(s);
  }

  function _chainHooks() {
    var prev = window.eohOnMessageComplete;
    window.eohOnMessageComplete = function (bubble, data) {
      try { if (typeof prev === 'function') prev(bubble, data); } catch (_) {}
      try { _collect(data); } catch (_) {}
    };
    var prevR = window.eohOnConversationRendered;
    window.eohOnConversationRendered = function (sess) {
      try { if (typeof prevR === 'function') prevR(sess); } catch (_) {}
      try { _rebuild(); } catch (_) {}   // rebuild files + sources from the loaded S.history
    };
  }

  async function _boot() {
    var f = await _getJSON(API + '/chat-inputs/features');
    _flags = (f && f.features) || {};
    if (_flags.chat_context_drawer === false) return;
    _css(); _build(); _chainHooks(); _rebuild(); _badge();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', _boot); else _boot();
})();
